import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';

// Pages
import Home from './pages/Home';
import NotreHistoire from './pages/NotreHistoire';
import MotDirecteur from './pages/MotDirecteur';
import NotreEquipe from './pages/NotreEquipe';
import NosStandards from './pages/NosStandards';

import Services from './pages/Services';
import Expertise from './pages/Expertise';
import Conseil from './pages/Conseil';
import Etudes from './pages/Etudes';
import Formation from './pages/Formation';

import Actualites from './pages/Actualites';
import NewsDetail from './pages/NewsDetail';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';

import Contact from './pages/Contact';
import PlaceholderPage from './pages/PlaceholderPage';

/**
 * Scrolls to the top of the page on every route change. Combined with the
 * `history.scrollRestoration = 'manual'` set in src/index.js, this makes both
 * page refreshes and SPA link navigation always land the user at the top.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />

        {/* À Propos */}
        <Route path="/notre-histoire" element={<NotreHistoire />} />
        <Route path="/mot-directeur" element={<MotDirecteur />} />
        <Route path="/notre-equipe" element={<NotreEquipe />} />
        <Route path="/nos-standards" element={<NosStandards />} />

        {/* Services */}
        <Route path="/services" element={<Services />} />
        <Route path="/services/expertise" element={<Expertise />} />
        <Route path="/services/conseil" element={<Conseil />} />
        <Route path="/services/etudes" element={<Etudes />} />
        <Route path="/services/formation" element={<Formation />} />

        {/* Blog & Actualités */}
        <Route path="/actualites" element={<Actualites />} />
        <Route path="/actualites/:id" element={<NewsDetail />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogDetail />} />

        {/* Contact */}
        <Route path="/contact" element={<Contact />} />

        {/* Toujours en construction */}
        <Route
          path="/bibliotheque"
          element={<PlaceholderPage title="Bibliothèque" subtitle="Ressources & Publications" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
